import { Button, styled } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { useParams, useNavigate } from 'react-router-dom';
import { isUndefinedOrNull, obterObjetoTodosComponentesTocados, getStringValue, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import IdentificacaoEvento from 'esocial.web.react.lib/cjs/components/util/IdentificacaoEvento';
import Catv_S_01_01_00Consulta from './Catv_S_01_01_00Consulta';
import Catv_S_01_00_00Consulta from './Catv_S_01_00_00Consulta';

const ContainerBotoesPagina = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'space-between'
}));

function CatConsulta({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const navigate = useNavigate();

    // Hook personalizado para requisições ao servidor
    const { get, post } = useRequisicaoControlada();

    function voltarListagem() {
        navigate(`/cat/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};
    objetoComponentesTocados['formulario'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (modelo != null) {
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        async function gerenciarAcaoFormularioCompletamenteValidado() {
            const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

            if (regraValidacaoFormulario.todosComponentesTocados) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0 && !new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter') {
                        await post("/sst/cat/salvar", modelo, voltarListagem, undefined, { mensagensResistentes: true });
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        gerenciarAcaoFormularioCompletamenteValidado();

    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    const processamentoResposta = (conteudoResposta) => {
        // Tratar os valores cuja representação em C# não seria traduzida em valor adequado para Javascript
        // Esse tratamento é importante para a aplicação correta das validações de obrigatoriedade
        setModelo({
            ...conteudoResposta,
            tipoCat: {
                ...conteudoResposta.tipoCat,
                valor: getStringValue(conteudoResposta.tipoCat.valor) === '0' ? null : conteudoResposta.tipoCat.valor
            },
            catEmitidaPor: {
                ...conteudoResposta.catEmitidaPor,
                valor: getStringValue(conteudoResposta.catEmitidaPor.valor) === '0' ? null : conteudoResposta.catEmitidaPor.valor
            },
            localAcidente: {
                ...conteudoResposta.localAcidente,
                tipoLocalAcidente: {
                    ...conteudoResposta.localAcidente.tipoLocalAcidente,
                    valor: getStringValue(conteudoResposta.localAcidente.tipoLocalAcidente.valor) === '0' ? null : conteudoResposta.localAcidente.tipoLocalAcidente.valor
                },
                tipoInscricao: {
                    ...conteudoResposta.localAcidente.tipoInscricao,
                    valor: getStringValue(conteudoResposta.localAcidente.tipoInscricao.valor) === '0' ? null : conteudoResposta.localAcidente.tipoInscricao.valor
                }
            },
            agenteCausador: {
                ...conteudoResposta.agenteCausador,
                valor: getStringValue(conteudoResposta.agenteCausador.valor) === '0' ? null : conteudoResposta.agenteCausador.valor
            },
            atestadoMedico: {
                ...conteudoResposta.atestadoMedico,
                naturezaLesao: {
                    ...conteudoResposta.atestadoMedico.naturezaLesao,
                    valor: getStringValue(conteudoResposta.atestadoMedico.naturezaLesao.valor) === '0' ? null : conteudoResposta.atestadoMedico.naturezaLesao.valor
                },
                orgaoClasse: {
                    ...conteudoResposta.atestadoMedico.orgaoClasse,
                    valor: getStringValue(conteudoResposta.atestadoMedico.orgaoClasse.valor) === '0' ? null : conteudoResposta.atestadoMedico.orgaoClasse.valor
                }
            }
        });
    };

    useEffect(() => {
        async function obterEvento() {
            await get(`sst/cat/obterEvento/${isUndefinedOrNull(idEvento) ? 0 : idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }

        obterEvento();
    }, []);

    return (
        (modelo !== null && Object.values(regraValidacaoFormulario).length > 0) ?
            <Fragment>
                <TituloPagina>Comunicação de Acidente de Trabalho</TituloPagina>

                <form id="formCat" onSubmit={(e) => handleSubmit(e)}>
                    <Display show={modelo.versao !== 'v_S_01_00_00'}>
                        <Catv_S_01_01_00Consulta modelo={modelo} setModelo={setModelo} visualizacao={visualizacao}></Catv_S_01_01_00Consulta>
                    </Display>

                    <Display show={modelo.versao == 'v_S_01_00_00'}>
                        <Catv_S_01_00_00Consulta modelo={modelo} setModelo={setModelo} visualizacao={visualizacao}></Catv_S_01_00_00Consulta>
                    </Display>

                    <Display show={visualizacao}>
                        <IdentificacaoEvento idEventoXml={modelo.idEventoXml} numeroRecibo={modelo.numeroRecibo} />
                    </Display>

                    <ContainerBotoesPagina>
                        <Display show={visualizacao}>
                            <Button variant="outlined" color="secondary" size="medium" onClick={() => navigate(-1)}>
                                Voltar
                            </Button>
                        </Display>

                        <Display show={!visualizacao}>
                            <Button variant="contained" color="primary" size="medium" type="submit">
                                Salvar
                            </Button>
                            <Button variant="outlined" color="primary" size="medium" onClick={() => navigate(-1)}>
                                Cancelar
                            </Button>
                        </Display>
                    </ContainerBotoesPagina>
                </form>
            </Fragment> :
            <ContentPreview />
    );
}

export default CatConsulta;